import BluffThis from "./sections/BluffThis";
import Bussines from "./sections/Bussines";
import Structur from "./sections/Structur";
import Talent from "./sections/Talent";
import WhoWe from "./sections/WhoWe";

const Main = () => {
  return (
    <main>
      <WhoWe />
      <BluffThis />
      <Bussines />
      <Talent />
      <Structur />
    </main>
  )
}

export default Main;